import { createContext, useContext } from 'react';

import { Feature, FeatureConfig } from '@app/constants';

export type FeatureFlagConfig<T extends Feature> = T extends keyof FeatureConfig
  ? FeatureConfig[T]
  : NonNullable<unknown>;

export interface FeatureFlag<T extends Feature = Feature> {
  name: T;
  isActive: boolean;
  config?: FeatureFlagConfig<T>;
}

export const FeatureFlagsContext = createContext<FeatureFlag[]>(null!);

export const useFeatureFlagsContext = (): FeatureFlag[] =>
  useContext(FeatureFlagsContext);
